import {httpGet, httpPut, httpDelete, httpPost, httpPostForm, httpDownload} from '@/util/request.js';
import appConfig from '@/config';

export default class XjOrderApi {
    static baseUrl = appConfig.gatewayUrl + appConfig.pdServicePath;
    // static baseUrl = "http://localhost:20065/pd-service" ;

    static XJORDER_LIST = XjOrderApi.baseUrl + "/manage/xjOrder/list"
    static XJORDER_LIST_EXPORT = XjOrderApi.baseUrl + "/manage/xjOrder/export/list"
    static XJORDER_DETAIL = XjOrderApi.baseUrl + "/manage/xjOrder/detail"
    static XJPOINT_PIC = XjOrderApi.baseUrl + "/manage/xjOrder/spotPic"
    static XJDETAIL_WRITEOFF = XjOrderApi.baseUrl + "/manage/xjOrder/writeOff"
    static TRANSFER_LIST = XjOrderApi.baseUrl + "/manage/xjOrder/transfer/list"
    static TRANSFER_LIST_EXPORT = XjOrderApi.baseUrl + "/manage/xjOrder/transfer/list/export"
    static XJORDER_DETAIL_EXPORT = XjOrderApi.baseUrl + "/manage/xjOrder/details/export"
    static XJORDER_PICS_EXPORT = XjOrderApi.baseUrl + "/manage/xjOrder/pics/export"
    static XJORDER_POOL = XjOrderApi.baseUrl + "/manage/xjOrder/pool"
    static XJORDER_POOL_EXPORT = XjOrderApi.baseUrl + "/manage/xjOrder/pool/export"
    static XJORDER_REACH = XjOrderApi.baseUrl + "/manage/xjOrder/reach"
    static XJORDER_REACH_EXPORT = XjOrderApi.baseUrl + "/manage/xjOrder/reach/export"
    static XJORDER_TEMP_EXPORT = XjOrderApi.baseUrl + "/manage/xjOrder/temp/export"
    static IMG_UPLOAD_URL = appConfig.gatewayUrl + appConfig.pdServicePath + "/common/file/upload";
	
	static AGAIN_WRITE_URL = XjOrderApi.baseUrl + "/manage/xjOrder/writeOffAgain"
    // static IMG_UPLOAD_URL =  "http://10.254.121.98:8080/pd-service/common/file/upload";


    static listXjOrder(param) {
        return httpPost(XjOrderApi.XJORDER_LIST, param);
    }

    static exportListData(params) {
        return httpDownload(XjOrderApi.XJORDER_LIST_EXPORT, params);
    }

    static detailXJOrder(params) {
        return httpGet(XjOrderApi.XJORDER_DETAIL, params);
    }

    static selectXJPointPic(params) {
        return httpGet(XjOrderApi.XJPOINT_PIC, params);
    }

    static writeOffXjDetail(params) {
        return httpPost(XjOrderApi.XJDETAIL_WRITEOFF, params);
    }

    static listOrderTransfer(param) {
        return httpPost(XjOrderApi.TRANSFER_LIST, param);
    }

    static exportData(params) {
        return httpDownload(XjOrderApi.XJORDER_DETAIL_EXPORT, params);
    }

    static exportXjOrderDetails(params) {
        return httpDownload(XjOrderApi.XJORDER_PICS_EXPORT, params);
    }

    static exportXjOrderPics(params) {
        return httpDownload(XjOrderApi.TRANSFER_LIST_EXPORT, params);
    }

    static listOrderPool(param) {
        return httpPost(XjOrderApi.XJORDER_POOL, param);
    }

    static exportOrderPool(params) {
        return httpDownload(XjOrderApi.XJORDER_POOL_EXPORT, params);
    }

    static listOrderReach(param) {
        return httpPost(XjOrderApi.XJORDER_REACH, param);
    }

    static exportOrderReach(params) {
        return httpDownload(XjOrderApi.XJORDER_REACH_EXPORT, params);
    }

    static exportOrderTemp(params) {
        return httpDownload(XjOrderApi.XJORDER_TEMP_EXPORT, params);
    }
	
	// 重新销项
	static againWrite(params) {
		return httpPost(XjOrderApi.AGAIN_WRITE_URL, params);
	}

    static handleResponse(response, scope, successFunc, errorFunc) {
        let data = response.data;
        if (data.code == 200) {
            if (successFunc && typeof successFunc == 'function') {
                successFunc(data.data);
            }
        } else {
            let text = data.msg
            scope.$dialog.error({
                text: text,
                title: "错误"
            });
            if (errorFunc && typeof errorFunc == 'function') {
                errorFunc(data);
            }
        }
    }

    static handleNetworkError(response, scope, errorFunc) {
        scope.$dialog.error({
            text: response.message,
            title: "错误"
        });
        if (errorFunc && typeof errorFunc == 'function') {
            errorFunc(response);
        }
    }

}